import { render, staticRenderFns } from "./ChangeFirstPasswordModal.vue?vue&type=template&id=5e7bf45a&scoped=true"
import script from "./ChangeFirstPasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangeFirstPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeFirstPasswordModal.vue?vue&type=style&index=0&id=5e7bf45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7bf45a",
  null
  
)

export default component.exports